export default "__VITE_ASSET__BJGtUwzj__"